const UserState = {
    LOADING: 'loading',
    ERROR_FETCHING: 'error_fetching',
    USER_LOADED: 'user_loaded'
};

export default UserState;
